// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { HistoryInformationMessage } from '@tls/sw91-communication/types/com.base';
import {
  CreateContainerCompleteMessage,
  CreateContainerProgressMessage,
} from '@tls/sw91-communication/types/com.api_tai_exporter';
import EventEmitter from 'eventemitter3';
import { EarlyStoppingMessage } from '@tls/sw91-communication/types/com.api_number_cruncher';
import { ModelEvaluationProgressResult } from 'model/ModelEvaluationProgressResult';
import { ProjectStatusAckMessage } from 'model/reponse/ProjectStatusAckMessage';
import { ProjectExportFailedMessage, ProjectExportProgressMessage } from 'model/reponse/ProjectExportProgressMessage';
import { GetAllLabelPackageInfoAckMessage } from '@tls/sw91-communication/types/com.api_db_access';
import {
  EvaluateQCProgramCompleteMessage,
  EvaluateQCProgramProgressMessage,
} from '@tls/sw91-communication/types/com.api_predictor';

interface UpdateEvents {
  onHistoryInformationUpdate: (message: HistoryInformationMessage) => void;
  onEarlyStopping: (message: EarlyStoppingMessage) => void;
  onExportProgress: (message: CreateContainerProgressMessage) => void;
  onExportFailed: (message: CreateContainerCompleteMessage) => void;
  onProjectExportProgress: (message: ProjectExportProgressMessage) => void;
  onProjectExportFailed: (message: ProjectExportFailedMessage) => void;
  imageDeleted: (projectId: string, imageMd5: string) => void;
  onEvaluationCompleted: (message: ModelEvaluationProgressResult) => void;
  onEvaluationFailed: (message: ModelEvaluationProgressResult) => void;
  onProjectStatusChanged: (message: ProjectStatusAckMessage) => void;
  onLabelPackageInfo: (message: GetAllLabelPackageInfoAckMessage[]) => void;
  onQCProgramEvaluationCompleted: (message: EvaluateQCProgramCompleteMessage) => void;
  onQCProgramEvaluationProgress: (message: EvaluateQCProgramProgressMessage) => void;
  onQCProgramEvaluationFailed: (message: EvaluateQCProgramCompleteMessage) => void;
}

class UpdateEmitter extends EventEmitter<UpdateEvents> {}

export default UpdateEmitter;
